import script from "./ThuChiSoGiaoDich.vue?vue&type=script&setup=true&lang=js"
export * from "./ThuChiSoGiaoDich.vue?vue&type=script&setup=true&lang=js"

import "./ThuChiSoGiaoDich.vue?vue&type=style&index=0&id=1051dd23&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1051dd23"]])

export default __exports__